<template>
  <main class="mb-3">
    <topBg :title="'供需对接'"></topBg>
    <div class="py-3 d-flex align-items-center  justify-content-center shadow-sm">
      <router-link class="link-router d-inline mb-1 list-group-item  lh-sm bg-white "
                   active-class="drop-link--Active"
                   :to="item.path"
                   v-for="(item,index) in supplyAndDemmandList"
                   :key="index">
        {{item.name}}
      </router-link>
    </div>
    <div class="container-lg max-width-1200 position-relative zindex-100 ">
      <!--         顶部领域-->
      <div class="d-flex align-items-start justify-content-between bg-light px-2  py-3 d-md-none d-block" >
        <div class="px-2 d-flex align-items-center justify-content-center "  >
          <div>所属领域：</div>
          <div class="text-primary">{{lychoisedName}}</div>
        </div>
        <div class="flex-shrink-0  point-curser ">
          <i class="bi bi-chevron-double-down ps-1 text-primary" v-if="!showChoiseList" @click="changeShowChoiseList"></i>
          <i class="bi bi-chevron-double-up ps-1 text-primary" v-else @click="changeShowChoiseList"></i>
        </div>
      </div>
      <div class=" bg-light bg-white collapseMybox d-md-none d-block" :class="{'collapsedHidden':!showChoiseList}" >
        <div class="border-0 mb-1 list-group-item   py-2 lh-sm flex-shrink-0 point-curser mx-2 px-2 d-inline-block pub-not-select"
             :class="{'text-primary ':!lychoisedId}"
             @click="lychoise()"
        >
          全部
        </div>
        <div class="border-0 mb-1 list-group-item  py-2 lh-sm flex-shrink-0 point-curser mx-2 px-2 d-inline-block pub-not-select"
             :class="{'text-primary':lychoisedId==item.ID}"
             @click="lychoise(item)"
             :id="item.ID"
             v-for="(item,index) in domain"
             :key="index">
          {{item.Name}}
        </div>
      </div>
      <!--左侧领域-->
      <div class="row g-2 ">
        <div class="col-md-3 col-12  d-none d-md-block rounded-3 " >
          <div
              class=" top-rounded list-header d-flex align-content-center py-3 px-4 bg-primary py-3 lh-lg text-white">
            <text v-if="currentPath==='/supplysndsemand/supply'">成果展示</text>
            <text v-else>需求大厅</text>
          </div>
          <div class="bg-white choise-tabs-left bottom-rounded shadow-sm">
            <a class="border-0 mb-1 list-group-item d-flex align-content-center py-3 px-4  lh-sm flex-shrink-0 point-curser"
               :class="{'text-primary linkactive':!lychoisedId}"
               @click="lychoise()"
            >
              全部
            </a>
            <a class="border-0 mb-1 list-group-item list-group-item-hover d-flex align-content-center py-3 px-4  lh-sm flex-shrink-0 point-curser"
               :class="{'text-primary linkactive':lychoisedId==item.ID}"
               @click="lychoise(item)"
               :id="item.ID"
               v-for="(item,index) in domain"
               :key="index">
              {{item.Name}}
            </a>

          </div>
        </div>
        <div class="col-md-9 col-12 bg-white shadow-sm rounded-3">
          <router-view v-slot="{ Component }">
            <component :is="Component" :lyList ="domain" :lyKey ="lychoisedId"/>
          </router-view>
        </div>

      </div>
    </div>
  </main>
</template>

<script setup>
import {supplyAndDemmandList} from "@/router/menusList"
import {ref, onUnmounted, onMounted, watch, computed} from "vue";
import router from "@/router";
import {useRouter} from "vue-router"
import store from "@/store";
const router1 =  useRouter()
let choiseCollapse; // collapse实例
const showChoiseList = ref(false)
const lychoisedId = ref()
const lychoisedName = ref("全部")
const currentPath = ref("/supplysndsemand/supply")
// 获取筛选项
const domain = computed(()=>store.state.dictModel.domain) // 所属领域
onUnmounted(()=>{
  if(choiseCollapse){
    choiseCollapse.dispose()
  }
})
onMounted(()=>{
  store.dispatch("dictModel/getAllDataDicAc") // 获取数据字典
  // initCollapse()
  currentPath.value = router1.currentRoute.value
})
watch(()=>router1.currentRoute.value,(nw,od)=>{
  currentPath.value = nw.path
})
// 领域选择
const lychoise = (item)=>{
  if(item){
    lychoisedId.value = item.ID
    lychoisedName.value = item.Name
  }else{
    lychoisedId.value = ""
    lychoisedName.value = "全部"
  }
  // showChoiseList.value = false // 关闭模态框
}





const changeShowChoiseList = ()=>{
  showChoiseList.value = !showChoiseList.value;

}

</script>

<style scoped lang="scss">
.bg-top {
  position: relative;
}
.mt-n3{
  margin-top: -4rem !important;
}
.drop-link--Active{
  font-weight: bold;
  background: #0d6efd !important;
  color: white !important;
}

.drop-link--Active-btn{
  color: #0d6efd;
}
.scroll-line{
  overflow-x: auto;  /* 启用水平滚动 */
  white-space: nowrap; /* 防止换行 */
}
li{
  list-style: none;
}

.collapseMybox{
  height: auto;
  transition: all 1s ease;
}
.collapsedHidden{
  height: 0 !important;
  overflow: hidden;
  opacity: 0;
  //transition: height 0.35s ease;
}
.link-router{
  width: calc(50% - 10px);
  max-width: 200px;
  text-align: center;
  padding: 0.7rem 0;
}
.link-router:first-child{
  border-radius: 5px 0 0 5px;
}
.link-router:last-child{
  border-radius:  0 5px 5px 0;
}
.top-rounded{
  border-radius:0.5rem 0.5rem 0 0;
}
.bottom-rounded{
  border-radius:0 0 0.5rem 0.5rem;
}

.linkactive{
  background: rgb(242, 246, 253);
  position: relative;
  &:after{
    content: "";
    width:4px;
    background:#0d6efd;
    height: 100%;
    left: 0;
    top: 0;
    position:absolute;
  }
}
.list-group-item-hover:hover{
  background: rgb(242, 246, 253);
}
</style>
